module.exports = __webpack_public_path__ + "static/media/DecAvantSig.e979dfb6.tsx";